import { gql, useQuery } from '@apollo/client';
import useStoreAndLanguageParams from '../../core/hooks/useStoreAndLanguageParams';
import type { Bicycle } from '../types';

const useMetaProducts = () => {
    const isIntercycle = APP_ENV.APPLICATION === 'intercycle';
    const { store, language } = useStoreAndLanguageParams();
    const {
        data: { metaProducts: products } = { metaProducts: [] },
        loading,
        error,
    } = useQuery<{
        metaProducts: Bicycle[];
    }>(
        gql`
            query metaProducts(
                $store: ID!
                $language: Language!
                $categoryEN: String
            ) {
                metaProducts(
                    store: $store
                    language: $language
                    categoryEN: $categoryEN
                ) {
                    id
                    model
                    manufacturerName
                    manufacturingStartYear
                    manufacturingEndYear
                    category
                    type
                    skuList
                    specificationAttributes {
                        name
                        value
                    }
                    sparePartDocument
                    sparePartSkuPrefix
                    images {
                        rendition176pxUrl
                    }
                }
            }
        `,
        {
            variables: {
                store,
                language,
                categoryEN: !isIntercycle ? undefined : 'Bicycles',
            },
        }
    );

    return {
        products,
        loading,
        error,
    };
};

export default useMetaProducts;
